//TODO: Tech-debt - Refactor this while component to reusable one
<template>
  <div>
    <b-modal
      :id="`updateavailability_${collection._id}`"
      ref="updateavailability"
      size="lg"
      modal-class="modal-primary custom-model"
      centered
      hide-header-close
      hide-header
      title="Update Availability"
      hide-footer
      @show="updateDefaultSelectedOption"
    >
      <div>
        <div class="pb-50 border-bottom">
          <span class="custom-modal-heading">Update Availability </span>
          <feather-icon
            class="float-right close-x-icon"
            icon="XIcon"
            size="24"
            @click="closeModal"
          />
        </div>
        <p class="mt-1">
          Update availability dates for your products
          <b-button
            class="downloadsheet ml-1"
            variant="primary"
            @click="downloadCatalog"
          >
            <div class="d-flex align-items-center">
              <feather-icon
                icon="DownloadIcon"
                class="mr-1"
                size="20"
              />
              Download Catalog
            </div>
          </b-button>
        </p>
        <label
          v-if="!catalogFile"
          for="uploadCatalog"
          class="fileDownload elements-center"
        >
          <feather-icon
            icon="UploadCloudIcon"
            size="50"
            color="skyblue"
          />
          <h4 class="font-weight-bolder"><b>Drag & Drop</b></h4>
          <h6>
            or click to select files from your system
          </h6>
        </label>
        <div
          v-if="catalogFile"
          class="d-flex file-droped mt-50"
        >
          <b-img
            :src="xlsxIcon"
            class="mx-1"
            alt="ErrorIcon"
          />
          <span class="catalog-label name">Name: {{ catalogFile.name }} </span>
          <span
            class="catalog-label size"
          >Size: {{ getSizeInKb(catalogFile.size) }} KB</span>
          <div
            v-if="catalogFile"
            class="delete-file d-flex align-items-center justify-content-center"
            @click="catalogFile = null"
          >
            <feather-icon
              icon="TrashIcon"
              size="24"
              fill="white"
              color="white"
            />
          </div>
        </div>
        <b-form-file
          id="uploadCatalog"
          v-model="catalogFile"
          name="uploadCatalog"
          accept=".xlsx"
          :hidden="true"
          plain
        />
      </div>
      <div>
        <div class="text-center mt-1">
          <b-button
            type="reset"
            class="mt-2 mr-2 px-sm-3 font-weight-bolder"
            variant="outline-info"
            @click="closeModal"
          >
            Cancel
          </b-button>
          <b-button
            type="submit"
            variant="info"
            class="mt-2 px-sm-3 font-weight-bolder"
            :disabled="isSaving || (!catalogFileLink && !catalogFile)"
            @click="openOrdersModal"
          >
            {{
              confirmedOrders.length ? 'Next' : isSaving ? 'Saving...' : 'Save'
            }}
          </b-button>
        </div>
      </div>
    </b-modal>
    <b-modal
      :id="`selectorders_${collection._id}`"
      ref="selectorders"
      size="lg"
      modal-class="modal-primary select-orders"
      centered
      hide-header-close
      hide-header
      hide-footer
    >
      <div>
        <div class="pb-50 border-bottom">
          <span
            class="custom-modal-heading color-dark-black"
          >Updating Orders
          </span>
          <feather-icon
            class="float-right close-x-icon"
            icon="XIcon"
            size="24"
            @click="closeModal"
          />
        </div>
        <b-row class="mt-1">
          <b-col class="col-10">
            <b-input-group
              class="input-group-merge"
            >
              <b-form-input
                type="text"
                class="form-control-merge"
                placeholder="Search order id, retailer name..."
                @input="onSearchOrders"
              />
              <b-input-group-append is-text>
                <feather-icon
                  icon="SearchIcon"
                  size="18"
                  class="cursor-pointer"
                />
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col class="col-2">
            <b-button
              class="w-100"
              variant="primary"
              @click="toggleSelectAllOrders"
            >
              {{ isSelectedOrders ? 'Deselect all' : 'Select all' }}
            </b-button>
          </b-col>
        </b-row>
        <b-row class="orders-modal-row-header">
          <b-col class="col-6">
            Order Id
          </b-col>
          <b-col class="col-6">
            Retailer Name
          </b-col>
        </b-row>
        <div class="orders-block scroll-bar">
          <b-form-checkbox-group
            v-model="selectedOrders"
            class="orders-checkbox"
          >
            <b-form-checkbox
              v-for="order in orderList"
              :key="order._id"
              :value="order._id"
            >
              <b-row class="w-100  cursor-pointer">
                <b-col class="col-6">
                  {{ order.orderSeqId }}
                </b-col>
                <b-col class="col-6">
                  {{ order.retailerName }}
                </b-col>
              </b-row>
            </b-form-checkbox>
          </b-form-checkbox-group>
        </div>
      </div>
      <div>
        <div class="text-center">
          <b-button
            type="reset"
            class="mt-2 mr-2 px-sm-3 font-weight-bolder"
            variant="outline-info"
            @click="closeOrderModal"
          >
            Back
          </b-button>
          <b-button
            type="submit"
            variant="info"
            class="mt-2 px-sm-3 font-weight-bolder"
            :disabled="isSaving"
            @click="uploadCollection"
          >
            {{ isSaving ? 'Saving...' : 'Save' }}
          </b-button>
        </div>
      </div>
    </b-modal>
    <b-modal
      :id="`${collection._id}-price-book`"
      size="lg"
      modal-class="modal-primary custom-model"
      centered
      hide-header-close
      hide-header
      title="Price Books"
      hide-footer
      @hide="onPriceBookModalHide"
    >
      <div
        class="mb-1"
        :class="{ 'disable-whole-div': isExportingPriceBook }"
      >
        <div class="pb-50">
          <span class="custom-modal-heading">Price Books</span>
          <feather-icon
            class="float-right close-x-icon"
            icon="XIcon"
            size="24"
            @click="onClickClosePriceBook"
          />
        </div>

        <template v-if="!isImportingPriceBook">
          <div class="w-100 mt-1">
            <div class="w-100 d-flex justify-content-end">
              <b-button
                v-if="!showCreatePriceBook"
                variant="primary"
                class="font-weight-bolder"
                @click="showCreatePriceBook = !showCreatePriceBook"
              >
                <feather-icon
                  icon="PlusIcon"
                  size="18"
                  class="align-text-bottom"
                />
                Create
              </b-button>
            </div>

            <div
              v-if="showCreatePriceBook"
              class="add-currency-container"
            >
              <span>Enter price book name</span>
              <b-form-input
                v-model="priceBookName"
                placeholder="Enter price book name"
                class="mt-75"
              />
              <div
                v-if="hasTransactionCurrencyFeature"
                class="mt-1"
              >
                <div class="mb-1">
                  <small class="text-muted">* If no currency is selected, collection's base currency will be used</small>
                </div>
                <b-dropdown
                  class="filter-dropdown"
                  variant="outline-none"
                  block
                  no-caret
                  menu-class="w-100 filter-dropdown-menu scroll-bar"
                  toggle-class="filter-dropdown-toggle"
                  no-flip
                >
                  <template #button-content>
                    <div
                      class="d-flex justify-content-between"
                      :class="{ 'has-value': !!selectedCurrency }"
                    >
                      <span>{{ selectedCurrency || 'Select currency' }}</span>
                      <feather-icon icon="ChevronDownIcon" />
                    </div>
                  </template>
                  <b-dropdown-text>
                    <b-form-input
                      placeholder="Search"
                      class="filter-dropdown-toggle"
                      @input="searchCurrency"
                    />
                    <div
                      v-if="!currencies.length"
                      class="py-2 text-center"
                    >
                      Nothing was found. Try another currency.
                    </div>
                  </b-dropdown-text>
                  <b-dropdown-item
                    v-for="name in currencies"
                    :key="name"
                    :active="selectedCurrency === name"
                    @click="onSelectCurrency(name)"
                  >
                    <div><span>{{ name }}</span></div>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
              <div class="mt-1 d-flex justify-content-end">
                <b-button
                  variant="outline-primary"
                  class="mr-1 font-weight-bolder"
                  @click="cancelCreatePriceBook"
                >
                  Cancel
                </b-button>
                <b-button
                  variant="primary"
                  :disabled="isCreating || !priceBookName"
                  class="font-weight-bolder"
                  @click="createPriceBook"
                >
                  {{ isCreating ? 'Creating' : 'Create' }}
                </b-button>
              </div>
            </div>
          </div>

          <!-- Master price book -->
          <div class="mt-1">
            <div class="border-bottom pr-75 py-75 font-inter font-weight-bold">
              Master Price Book
            </div>
            <div class="price-book-list">
              <div class="d-flex align-items-center justify-content-between border-bottom p-75">
                <div>Master Price Book</div>
                <div class="d-flex justify-content-end">
                  <b-button
                    class="font-weight-bold font-size-16-px flex-wrap elements-center mr-1"
                    variant="outline-primary"
                    @click="exportMasterPriceBook()"
                  >
                    <b-spinner
                      v-if="isExportingPriceBook && !exportingPriceBookId"
                      class="mr-50"
                      small
                    />
                    <feather-icon
                      v-else
                      icon="UploadIcon"
                      size="14"
                      class="mr-50"
                    />
                    Export
                  </b-button>
                  <b-button
                    variant="outline-primary"
                    @click="onClickImportPriceBook()"
                  >
                    <feather-icon
                      icon="DownloadIcon"
                      size="14"
                      class="mr-50"
                    />
                    Import
                  </b-button>
                </div>
              </div>
            </div>
          </div>

          <!-- Price book list -->
          <div
            v-if="priceBookList.length"
            class="mt-1"
          >
            <div class="border-bottom pr-75 py-75 font-inter font-weight-bold">
              All Price Books ({{ priceBookList.length }})
            </div>
            <div class="price-book-list scroll-bar">
              <div
                v-for="priceBook in priceBookList"
                :key="priceBook._id"
                class="w-100 d-flex align-items-center justify-content-between border-bottom p-75"
              >
                <div class="col-7 text-wrap d-flex align-items-center">
                  <div class="flex-grow-1 mr-2">
                    <template v-if="!priceBook.isEditing">
                      <h6 class="mb-0 font-weight-bold d-flex align-items-center">
                        <span
                          class="text-truncate"
                          style="max-width: 160px;"
                          :title="getPriceBookNameWithoutCurrency(priceBook.priceBookName)"
                        >
                          {{ getPriceBookNameWithoutCurrency(priceBook.priceBookName) }}
                        </span>
                        <span
                          v-if="getPriceBookCurrency(priceBook.priceBookName)"
                          class="ml-25"
                        >
                          ({{ getPriceBookCurrency(priceBook.priceBookName) }})
                        </span>
                      </h6>
                    </template>
                    <template v-else>
                      <div
                        class="rename-box"
                      >
                        <b-form-input
                          v-model="priceBook.newName"
                          size="sm"
                          class="rename-input"
                          maxlength="25"
                          :state="validateName(priceBook.newName)"
                          @input="handleNameInput($event, priceBook, 'newName')"
                          @keyup.esc="cancelRename(priceBook)"
                        />
                        <div class="rename-actions">
                          <feather-icon
                            v-if="priceBook.newName && validateName(priceBook.newName) && !isRenaming"
                            icon="CheckIcon"
                            size="14"
                            class="rename-action-icon mr-1"
                            @click="renamePriceBook(priceBook)"
                          />
                          <feather-icon
                            v-if="!isRenaming"
                            icon="XIcon"
                            size="14"
                            class="rename-action-icon text-danger"
                            @click="cancelRename(priceBook)"
                          />
                        </div>
                      </div>
                      <small
                        v-if="!priceBook.newName"
                        class="text-danger"
                      >
                        Price Book Name is required
                      </small>
                      <small
                        v-else-if="priceBook.newName.length > 25"
                        class="text-danger"
                      >
                        Name must be 25 characters or less
                      </small>
                    </template>
                  </div>
                  <div
                    v-if="hasTransactionCurrencyFeature"
                    class="d-flex align-items-center"
                  >
                    <feather-icon
                      icon="EditIcon"
                      size="16"
                      class="cursor-pointer mr-1"
                      @click="startRenamePricebook(priceBook)"
                    />
                    <feather-icon
                      icon="TrashIcon"
                      size="16"
                      class="cursor-pointer"
                      @click="deletePricebook(priceBook)"
                    />
                  </div>
                </div>
                <div class="d-flex justify-content-end">
                  <b-button
                    class="font-weight-bold font-size-16-px flex-wrap elements-center mr-1"
                    variant="outline-primary"
                    @click="exportPriceBook(priceBook)"
                  >
                    <b-spinner
                      v-if="isExportingPriceBook && exportingPriceBookId === priceBook._id"
                      class="mr-50"
                      small
                    />
                    <feather-icon
                      v-else
                      icon="UploadIcon"
                      size="14"
                      class="mr-50"
                    />
                    Export
                  </b-button>
                  <b-button
                    variant="outline-primary"
                    @click="onClickImportPriceBook(priceBook)"
                  >
                    <feather-icon
                      icon="DownloadIcon"
                      size="14"
                      class="mr-50"
                    />
                    Import
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </template>

        <!-- Import UI -->
        <template v-else>
          <div
            @dragover.prevent
            @drop.prevent
          >
            <p class="mt-1">
              Upload file for
              {{ selectedPriceBook ? selectedPriceBook.priceBookName : 'Master Price Book' }}
            </p>
            <div
              v-if="!priceBookFile"
              class="fileDownload elements-center"
              :class="{'cursor-copy': isDragging}"
              @click="$refs.uploadPricebookFile.$el.click()"
              @drop="onDropPriceBookFile"
              @dragover.prevent="handleDragOver"
              @dragleave.prevent="handleDragLeave"
            >
              <feather-icon
                icon="UploadCloudIcon"
                size="50"
                color="skyblue"
              />
              <h4 class="font-weight-bolder">
                <b>Drag & Drop</b>
              </h4>
              <h6>or click to select files from your system</h6>
            </div>
            <div
              v-if="priceBookFile"
              class="d-flex file-droped mt-50"
            >
              <b-img
                :src="xlsxIcon"
                class="mx-1"
                alt="ErrorIcon"
              />
              <span class="catalog-label name">Name: {{ priceBookFile.name }}</span>
              <span class="catalog-label size">Size: {{ getSizeInKb(priceBookFile.size) }} KB</span>
              <div
                class="delete-file d-flex align-items-center justify-content-center"
                @click="priceBookFile = null"
              >
                <feather-icon
                  icon="TrashIcon"
                  size="24"
                  fill="white"
                  color="white"
                />
              </div>
            </div>
            <b-form-file
              ref="uploadPricebookFile"
              v-model="priceBookFile"
              name="uploadPricebookFile"
              accept=".xlsx"
              :hidden="true"
              plain
            />
          </div>
          <div class="elements-center">
            <b-button
              type="reset"
              class="mt-2 mr-2 px-sm-3 font-weight-bolder"
              variant="outline-info"
              :disabled="isUploading"
              @click="onClickBackPriceBook"
            >
              Back
            </b-button>
            <b-button
              type="submit"
              variant="info"
              class="mt-2 px-sm-3 font-weight-bolder"
              :disabled="isUploading || !priceBookFile"
              @click="importPriceBook"
            >
              {{ isUploading ? 'Uploading...' : 'Upload' }}
            </b-button>
          </div>
        </template>
      </div>
    </b-modal>

    <!-- Currency book modal -->
    <b-modal
      :id="`${collection._id}_currency_book`"
      size="lg"
      modal-class="modal-primary custom-model"
      centered
      hide-header-close
      hide-header
      title="Currencies"
      hide-footer
      :no-close-on-backdrop="isUploadingCurrencyBook"
      :no-close-on-esc="isUploadingCurrencyBook"
      @hide="resetCurrencyInput"
    >
      <template v-if="!selectedCurrencyForImport">
        <div>
          <div class="pb-50">
            <span class="custom-modal-heading">Currencies </span>
            <feather-icon
              class="float-right close-x-icon"
              icon="XIcon"
              size="24"
              @click="closeModal"
            />
          </div>
          <!-- Body -->
          <div
            class="w-100 mt-1 mb-1"
            :class="{'disable-whole-div': isExportingCurrency}"
          >
            <div class="w-100">
              <b-button
                v-if="!showAddCurrencyField"
                class="font-weight-bold font-size-16-px flex-wrap elements-center ml-auto"
                variant="custom-primary"
                @click="showAddCurrencyField=true"
              >
                <feather-icon
                  icon="PlusIcon"
                  size="20"
                  class="mr-25"
                />
                Add new
              </b-button>
              <div
                v-else
                class="add-currency-container"
              >
                <div class="text-primary font-weight-bold">
                  Add new currency
                </div>
                <div class="mt-1">
                  <b-dropdown
                    class="filter-dropdown"
                    variant="outline-none"
                    block
                    no-caret
                    menu-class="w-100 filter-dropdown-menu scroll-bar"
                    toggle-class="filter-dropdown-toggle"
                    no-flip
                  >
                    <template #button-content>
                      <div
                        class="d-flex justify-content-between"
                        :class="{ 'has-value': !!selectedCurrency }"
                      >
                        <span> {{ selectedCurrency || 'Select currency' }} </span>
                        <feather-icon icon="ChevronDownIcon" />
                      </div>
                    </template>
                    <b-dropdown-text>
                      <b-form-input
                        placeholder="Search"
                        class="filter-dropdown-toggle"
                        @input="searchCurrency"
                      />
                      <div
                        v-if="!currencies.length"
                        class="py-2 text-center"
                      >
                        Nothing was found. Try another currency.
                      </div>
                    </b-dropdown-text>
                    <b-dropdown-item
                      v-for="name in currencies"
                      :key="name"
                      :active="selectedCurrency === name"
                      @click="onSelectCurrency(name)"
                    >
                      <div>
                        <span>
                          {{ name }}
                        </span>
                      </div>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
                <div class="w-100 d-flex justify-content-end mt-1">
                  <b-button
                    class="font-weight-bold font-size-16-px flex-wrap elements-center mr-1"
                    variant="outline-primary"
                    :disabled="isSavingCurrency"
                    @click="showAddCurrencyField=false"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    class="font-weight-bold font-size-16-px flex-wrap elements-center"
                    variant="custom-primary"
                    :disabled="!selectedCurrency || isSavingCurrency"
                    @click="onAddCurrency"
                  >
                    <b-spinner
                      v-if="isSavingCurrency"
                      class="mr-50"
                      small
                    />
                    <span v-else>
                      Add
                    </span>
                  </b-button>
                </div>

              </div>
            </div>

            <!-- Master Currency Book -->
            <div class="mt-1">
              <div class="font-inter font-weight-bold">
                Master Currency Book
              </div>
              <div class="border-top border-bottom d-flex pt-50 pb-50 mt-50">
                <div class="col-4 d-flex align-items-center">
                  <span class="text-secondary text-nowrap mr-5-px">Base Currency:</span> {{ baseCurrency }}
                </div>
                <div class="col-8 d-flex justify-content-end">
                  <b-button
                    class="font-weight-bold font-size-16-px flex-wrap elements-center mr-1"
                    variant="outline-primary"
                    @click="exportCurrencies()"
                  >
                    <b-spinner
                      v-if="isExportingCurrency && !exportingCurrency"
                      class="mr-50"
                      small
                    />
                    <feather-icon
                      v-else
                      icon="UploadIcon"
                      size="14"
                      class="mr-50"
                    />
                    Export
                  </b-button>
                  <b-button
                    class="font-weight-bold font-size-16-px flex-wrap elements-center"
                    variant="outline-primary"
                    @click="onClickImportCurrency(baseCurrency)"
                  >
                    <feather-icon
                      icon="DownloadIcon"
                      size="14"
                      class="mr-50"
                    />
                    Import
                  </b-button>
                </div>
              </div>
            </div>

            <!-- File currencies -->
            <div
              v-if="currencyFileList.length"
              class="mt-1"
            >
              <div class="font-inter font-weight-bold">
                Additional Currencies({{ currencyFileList.length }})
              </div>
              <div
                v-for="currency of currencyFileList"
                :key="currency"
                class="border-top d-flex pt-50 mt-50"
              >
                <div class="col-4 d-flex align-items-center">
                  {{ currency }}
                </div>
                <div class="col-8 d-flex justify-content-end">
                  <b-button
                    class="font-weight-bold font-size-16-px flex-wrap elements-center mr-1"
                    variant="outline-primary"
                    @click="exportCurrencies(currency)"
                  >
                    <b-spinner
                      v-if="isExportingCurrency && exportingCurrency === currency"
                      class="mr-50"
                      small
                    />
                    <feather-icon
                      v-else
                      icon="UploadIcon"
                      size="14"
                      class="mr-50"
                    />
                    Export
                  </b-button>
                  <b-button
                    class="font-weight-bold font-size-16-px flex-wrap elements-center"
                    variant="outline-primary"
                    @click="onClickImportCurrency(currency)"
                  >
                    <feather-icon
                      icon="DownloadIcon"
                      size="14"
                      class="mr-50"
                    />
                    Import
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div
          :class="{'disable-whole-div' : isUploadingCurrencyBook}"
          @dragover.prevent
          @drop.prevent
        >
          <div>
            <p class="mt-1">
              Upload file for {{ selectedCurrencyForImport === baseCurrency ? 'Master Currency Book' : selectedCurrencyForImport }}
            </p>
            <div
              v-if="!currencyBookFile"
              class="fileDownload elements-center"
              :class="{ 'cursor-copy': isDragging }"
              @click="$refs.uploadCatalog.$el.click()"
              @drop="onDropCurrencyFile"
              @dragover.prevent="handleDragOver"
              @dragleave.prevent="handleDragLeave"
            >
              <feather-icon
                icon="UploadCloudIcon"
                size="50"
                color="skyblue"
              />
              <h4 class="font-weight-bolder">
                <b>Drag & Drop</b>
              </h4>
              <h6>or click to select files from your system</h6>
            </div>
            <div
              v-if="currencyBookFile"
              class="d-flex file-droped mt-50"
            >
              <b-img
                :src="xlsxIcon"
                class="mx-1"
                alt="ErrorIcon"
              />
              <span class="catalog-label name">Name: {{ currencyBookFile.name }} </span>
              <span
                class="catalog-label size"
              >Size: {{ getSizeInKb(currencyBookFile.size) }} KB</span>
              <div
                v-if="currencyBookFile"
                class="delete-file d-flex align-items-center justify-content-center"
                @click="currencyBookFile = null"
              >
                <feather-icon
                  icon="TrashIcon"
                  size="24"
                  fill="white"
                  color="white"
                />
              </div>
            </div>
            <b-form-file
              ref="uploadCatalog"
              v-model="currencyBookFile"
              name="uploadCatalog"
              accept=".xlsx"
              :hidden="true"
              plain
            />
          </div>
          <div class="elements-center">
            <b-button
              type="reset"
              class="mt-2 mr-2 px-sm-3 font-weight-bolder"
              variant="outline-info"
              :disabled="isUploadingCurrencyBook"
              @click="resetCurrencyInput"
            >
              Back
            </b-button>
            <b-button
              type="submit"
              variant="info"
              class="mt-2 px-sm-3 font-weight-bolder"
              :disabled="isUploadingCurrencyBook || !currencyBookFile"
              @click="handleCurrencyImport"
            >
              {{ isUploadingCurrencyBook ? 'Uploading...' : 'Upload' }}
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>

    <!-- Segmentation Book Modal -->
    <b-modal
      :id="`${collection._id}-segmentation-book`"
      size="lg"
      modal-class="modal-primary custom-model"
      centered
      hide-header-close
      hide-header
      title="Segmentation Books"
      hide-footer
      @hide="closeSegmentationBook"
    >
      <div
        class="mb-1"
        :class="{ 'disable-whole-div': isExportingSegmentationBook }"
      >
        <div class="pb-50">
          <span class="custom-modal-heading">Segmentation Books</span>
          <feather-icon
            class="float-right close-x-icon"
            icon="XIcon"
            size="24"
            @click="onClickCloseSegmentationBook"
          />
        </div>

        <template v-if="!isImportingSegmentationBook">
          <!-- Spinner while loading -->
          <template v-if="isLoadingSegmentationBooks">
            <div class="text-center py-5">
              <b-spinner
                variant="primary"
                small
              />
              <p class="mt-1 mb-0 text-muted font-italic">
                Loading segmentation books...
              </p>
            </div>
          </template>

          <!-- Main content shown only when not loading -->
          <template v-else>
            <div class="w-100 mt-1">
              <div class="w-100 d-flex justify-content-end">
                <b-button
                  v-if="!showCreateSegmentationBook"
                  variant="primary"
                  class="font-weight-bolder"
                  @click="showCreateSegmentationBook = !showCreateSegmentationBook"
                >
                  <feather-icon
                    icon="PlusIcon"
                    size="18"
                    class="align-text-bottom"
                  />
                  Create
                </b-button>
              </div>

              <div
                v-if="showCreateSegmentationBook"
                class="add-currency-container"
              >
                <span>Enter segmentation book name</span>
                <b-form-input
                  v-model="segmentationBookName"
                  placeholder="Enter segmentation book name"
                  class="mt-75"
                />
                <div class="mt-1 d-flex justify-content-end">
                  <b-button
                    variant="outline-primary"
                    class="mr-1 font-weight-bolder"
                    @click="showCreateSegmentationBook = false"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    variant="primary"
                    :disabled="!segmentationBookName || isCreatingSegmentationBook"
                    class="font-weight-bolder"
                    @click="createSegmentationBook"
                  >
                    {{ isCreatingSegmentationBook ? 'Creating...' : 'Create' }}
                  </b-button>
                </div>
              </div>
            </div>

            <!-- Master Segmentation Book -->
            <div class="mt-1">
              <div class="border-bottom pr-75 py-75 font-inter font-weight-bold">
                Master Segmentation Book
              </div>
              <div class="price-book-list">
                <div class="d-flex align-items-center justify-content-between border-bottom p-75">
                  <div>Master Segmentation Book</div>
                  <div class="d-flex justify-content-end">
                    <b-button
                      class="font-weight-bold font-size-16-px flex-wrap elements-center mr-1"
                      variant="outline-primary"
                      @click="exportMasterSegmentationBook()"
                    >
                      <b-spinner
                        v-if="isExportingSegmentationBook && !exportingSegmentationBookId"
                        class="mr-50"
                        small
                      />
                      <feather-icon
                        v-else
                        icon="UploadIcon"
                        size="14"
                        class="mr-50"
                      />
                      Export
                    </b-button>
                    <b-button
                      variant="outline-primary"
                      class="font-weight-bold font-size-16-px flex-wrap elements-center"
                      @click="onClickImportSegmentationBook()"
                    >
                      <feather-icon
                        icon="DownloadIcon"
                        size="14"
                        class="mr-50"
                      />
                      Import
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

            <!-- All Segmentation Books -->
            <div
              v-if="segmentationBooks.length"
              class="mt-1"
            >
              <div class="border-bottom pr-75 py-75 font-inter font-weight-bold">
                All Segmentation Books ({{ segmentationBooks.length }})
              </div>
              <div class="price-book-list scroll-bar">
                <div
                  v-for="book in segmentationBooks"
                  :key="book._id"
                  class="w-100 d-flex align-items-center justify-content-between border-bottom p-75"
                >
                  <div class="col-7 text-wrap d-flex align-items-center">
                    <div class="flex-grow-1 mr-2">
                      <template v-if="!book.isEditing">
                        <h6 class="mb-0 font-weight-bold">
                          <span
                            class="text-truncate d-inline-block"
                            :title="book.segmentationBookName"
                            style="max-width: 200px;"
                          >
                            {{ book.segmentationBookName }}
                          </span>
                        </h6>
                      </template>
                      <template v-else>
                        <div
                          class="position-relative d-inline-block"
                          style="width: 200px"
                        >
                          <b-form-input
                            v-model="book.newName"
                            size="sm"
                            class="rename-input"
                            maxlength="25"
                            :state="validateName(book.newName)"
                            @input="handleNameInput($event, book, 'newName')"
                            @keyup.esc="cancelRename(book)"
                          />
                          <div class="rename-actions">
                            <feather-icon
                              v-if="book.newName && validateName(book.newName) && !isRenaming"
                              icon="CheckIcon"
                              size="14"
                              class="rename-action-icon mr-1"
                              @click="renameSegmentationBook(book)"
                            />
                            <feather-icon
                              v-if="!isRenaming"
                              icon="XIcon"
                              size="14"
                              class="rename-action-icon text-danger"
                              @click="cancelRename(book)"
                            />
                          </div>
                        </div>
                        <small
                          v-if="!book.newName"
                          class="text-danger"
                        >
                          Segmentation Book Name is required
                        </small>
                        <small
                          v-else-if="book.newName.length > 25"
                          class="text-danger"
                        >
                          Name must be 25 characters or less
                        </small>
                      </template>
                    </div>
                    <div class="d-flex align-items-center">
                      <feather-icon
                        icon="EditIcon"
                        size="16"
                        class="cursor-pointer mr-1"
                        @click="startRename(book)"
                      />
                      <feather-icon
                        icon="TrashIcon"
                        size="16"
                        class="cursor-pointer"
                        @click="deleteSegmentationBook(book)"
                      />
                    </div>
                  </div>
                  <div class="d-flex justify-content-end">
                    <b-button
                      class="font-weight-bold font-size-16-px flex-wrap elements-center mr-1"
                      variant="outline-primary"
                      :disabled="isExportingSegmentationBook && exportingSegmentationBookId === book._id"
                      @click="exportSegmentationBook(book)"
                    >
                      <b-spinner
                        v-if="isExportingSegmentationBook && exportingSegmentationBookId === book._id"
                        class="mr-50"
                        small
                      />
                      <feather-icon
                        v-else
                        icon="UploadIcon"
                        size="14"
                        class="mr-50"
                      />
                      Export
                    </b-button>
                    <b-button
                      variant="outline-primary"
                      class="font-weight-bold font-size-16-px flex-wrap elements-center"
                      @click="onClickImportSegmentationBook(book)"
                    >
                      <feather-icon
                        icon="DownloadIcon"
                        size="14"
                        class="mr-50"
                      />
                      Import
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>

        <!-- Import UI -->
        <template v-else>
          <div>
            <p class="mt-1">
              Upload file for {{ selectedSegmentationBook ? selectedSegmentationBook.segmentationBookName : 'Master Segmentation Book' }}
            </p>
            <label
              v-if="!segmentationBookFile"
              for="uploadSegmentationBook"
              class="fileDownload elements-center"
            >
              <feather-icon
                icon="UploadCloudIcon"
                size="50"
                color="skyblue"
              />
              <h4 class="font-weight-bolder"><b>Drag & Drop</b></h4>
              <h6>or click to select files from your system</h6>
            </label>
            <div
              v-if="segmentationBookFile"
              class="d-flex file-droped mt-50"
            >
              <b-img
                :src="xlsxIcon"
                class="mx-1"
                alt="ExcelIcon"
              />
              <span class="catalog-label name">Name: {{ segmentationBookFile.name }} </span>
              <span class="catalog-label size">Size: {{ getSizeInKb(segmentationBookFile.size) }} KB</span>
              <div
                class="delete-file d-flex align-items-center justify-content-center"
                @click="segmentationBookFile = null"
              >
                <feather-icon
                  icon="TrashIcon"
                  size="24"
                  fill="white"
                  color="white"
                />
              </div>
            </div>
            <b-form-file
              id="uploadSegmentationBook"
              v-model="segmentationBookFile"
              name="uploadSegmentationBook"
              accept=".xlsx"
              :hidden="true"
              plain
            />
          </div>
          <div class="elements-center">
            <b-button
              type="reset"
              class="mt-2 mr-2 px-sm-3 font-weight-bolder"
              variant="outline-info"
              :disabled="isUploading"
              @click="onClickBackSegmentationBook"
            >
              Back
            </b-button>
            <b-button
              type="submit"
              variant="info"
              class="mt-2 px-sm-3 font-weight-bolder"
              :disabled="isUploading || !segmentationBookFile"
              @click="importSegmentationBook"
            >
              {{ isUploading ? 'Uploading...' : 'Upload' }}
            </b-button>
          </div>
        </template>
      </div>
    </b-modal>
    <currency-update-modals
      :collection-id="collection._id"
      :order-data="conflictingOrders"
      @do-not-update-orders="handleDoNotUpdateOrders"
      @update-orders="handleUpdateOrders"
      @hide="isUploadingCurrencyBook = false"
    />
    <!-- Order Selection Modal for Price Book Import -->
    <b-modal
      :id="`select_orders_pricebook_import_${collection._id}`"
      ref="selectordersPricebook"
      size="lg"
      modal-class="modal-primary select-orders"
      centered
      hide-header-close
      hide-header
      hide-footer
      @show="resetSelectedPriceBookOrders"
    >
      <div>
        <div class="pb-50 border-bottom">
          <span class="custom-modal-heading color-dark-black">Select Orders for Price Book Import</span>
          <feather-icon
            class="float-right close-x-icon"
            icon="XIcon"
            size="24"
            @click="closePriceBookOrderModal"
          />
        </div>
        <b-row class="mt-1">
          <b-col class="col-10">
            <b-input-group class="input-group-merge">
              <b-form-input
                type="text"
                class="form-control-merge"
                placeholder="Search order id, retailer name..."
                @input="onSearchPriceBookOrders"
              />
              <b-input-group-append is-text>
                <feather-icon
                  icon="SearchIcon"
                  size="18"
                  class="cursor-pointer"
                />
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col class="col-2">
            <b-button
              class="w-100"
              variant="primary"
              @click="toggleSelectAllPriceBookOrders"
            >
              {{ isSelectedPriceBookOrders ? 'Deselect all' : 'Select all' }}
            </b-button>
          </b-col>
        </b-row>
        <b-row class="orders-modal-row-header">
          <b-col class="col-6">
            Order Id
          </b-col>
          <b-col class="col-6">
            Retailer Name
          </b-col>
        </b-row>
        <div class="orders-block scroll-bar">
          <b-form-checkbox-group
            v-model="selectedPriceBookOrders"
            class="orders-checkbox"
          >
            <b-form-checkbox
              v-for="order in priceBookOrderList"
              :key="order._id"
              :value="order._id"
            >
              <b-row class="w-100 cursor-pointer">
                <b-col class="col-6">
                  {{ order.orderSeqId || order.seqId || 'N/A' }}
                </b-col>
                <b-col class="col-6">
                  {{ order.retailerName || 'N/A' }}
                </b-col>
              </b-row>
            </b-form-checkbox>
          </b-form-checkbox-group>
        </div>
      </div>
      <div>
        <div class="text-center">
          <b-button
            type="reset"
            class="mt-2 mr-2 px-sm-3 font-weight-bolder"
            variant="outline-info"
            @click="closePriceBookOrderModal"
          >
            Cancel
          </b-button>
          <b-button
            type="submit"
            variant="info"
            class="mt-2 px-sm-3 font-weight-bolder"
            :disabled="isUploading"
            @click="confirmPriceBookImport"
          >
            {{ isUploading ? 'Importing...' : 'Import' }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BImg,
  BFormFile,
  BModal,
  BFormCheckboxGroup,
  BFormCheckbox,
  BRow,
  BCol,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BDropdown,
  BDropdownText,
  BDropdownItem,
  BSpinner,
} from 'bootstrap-vue'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import NotificationMixin from '@/views/mixins/NotificationMixin.vue'
import { apiToastSuccess, apiToastWarning } from '@/@core/utils/toast'
import store from '@/store'
import {
  CREATE_PRICE_BOOK,
  EXPORT_CURRENCIES,
  GET_PRICE_BOOK,
  IMPORT_CURRENCIES,
  IMPORT_PRICE_BOOK,
  UPDATE_COLLECTION,
  UPDATE_CURRENCIES,
  DOWNLOAD_MASTER_PRICEBOOK,
  DOWNLOAD_MASTER_SEGMENTATION_BOOK,
  DOWNLOAD_AVAILABILITY,
  CREATE_SEGMENTATION,
  IMPORT_SEGMENTATION,
  GET_SEGMENTATION_BOOKS,
  DELETE_SEGMENTATION_BOOK,
  RENAME_SEGMENTATION,
  DELETE_PRICEBOOK,
  RENAME_PRICEBOOK,
  SET_IS_UPLOADING_CURRENCY_BOOK,
} from '@/store/modules/collection.module'
import {
  getSizeInKb, formatObject, parseErrorObject,
} from '@/@core/utils/utils'
import { constants as c } from '@kingpin-global/kingpin-utils-frontend'
import { UPLOAD_DOCUMENTS, DOWNLOAD_FILE } from '@/store/modules/common.module'
import analytics, { getCollectionMixpanelObj } from '@/@core/utils/analytics'
import constants, {
  availableCurrencies,
  FILE_FORMATS,
  FLAG_CONSTANTS,
  DOWNLOAD_TYPES,
} from '@/constants'
import {
GET_ORDERS_INFO_BY_COLLECTION_ID_AND_CURRENCY, GET_ORDERS_BY_COLLECTION_SEQ_IDS,
} from '@/store/modules/order.module'
import CurrencyUpdateModals from './CurrencyUpdateModals.vue'

const { FILE_TYPES } = c

const { MASTER_PRICE_BOOK } = constants.TRACKS.ACTIONS

export default {
  components: {
    BButton,
    BImg,
    BFormFile,
    BModal,
    BFormCheckboxGroup,
    BFormCheckbox,
    BRow,
    BCol,
    FeatherIcon,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BDropdown,
    BDropdownText,
    BDropdownItem,
    BSpinner,
    CurrencyUpdateModals,
  },
  mixins: [NotificationMixin],
  props: {
    collection: {
      type: Object,
      default: () => {},
    },
    fetchCollections: {
      type: Function,
      default() {},
    },
  },
  data() {
    return {
      isRenaming: false,
      // Segmentation Book data
      showCreateSegmentationBook: false,
      segmentationBookName: '',
      isCreatingSegmentationBook: false,
      isImportingSegmentationBook: false,
      segmentationBookFile: null,
      segmentationBooks: [],
      selectedSegmentationBook: null,
      isExportingSegmentationBook: false,
      exportingSegmentationBookId: null,
      isLoadingSegmentationBooks: false,
      orderList: [],
      confirmedOrders: [],
      selectedOrders: [],
      priceBookOrderList: [],
      allPriceBookOrders: [],
      selectedPriceBookOrders: [],
      uploadedPriceBookFileLink: null,
      xlsxIcon: require('@/assets/images/icons/xlsxIcon.svg'),
      collectionId: this.collection._id,
      catalogFile: null,
      catalogFileLink: null,
      isSaving: false,
      getSizeInKb,
      showCreatePriceBook: false,
      priceBookName: '',
      isCreating: false,
      priceBookList: [],
      isImportingPriceBook: false,
      selectedPriceBook: null,
      priceBookFile: null,
      isUploading: false,
      showAddCurrencyField: false,
      selectedCurrency: null,
      currencyFileList: [],
      currencies: availableCurrencies || [],
      isExportingCurrency: false,
      exportingCurrency: '',
      currencyBookFile: null,
      selectedCurrencyForImport: '',
      isSavingCurrency: false,
      isExportingPriceBook: false,
      exportingPriceBookId: null,
      conflictingOrders: [],
      isDragging: false,
    }
  },
    computed: {
    isSelectedOrders() {
      return !!this.selectedOrders.length
    },
    isSelectedPriceBookOrders() {
      return !!this.selectedPriceBookOrders.length && this.selectedPriceBookOrders.length === this.allPriceBookOrders.length
    },
    isUploadingCurrencyBook: {
      get() {
        return this.$store.state.collection.isUploadingCurrencyBook
      },
      set(value) {
        this.$store.commit(SET_IS_UPLOADING_CURRENCY_BOOK, value)
      },
    },
    baseCurrency() {
      return this.$store.getters.profile?.currency
    },
    hasTransactionCurrencyFeature() {
      return store.state.flags[FLAG_CONSTANTS.TRANSACTION_CURRENCY]
    },
    hasImportPricebookOrderFeature() {
      return store.state.flags[FLAG_CONSTANTS.IMPORT_PRICEBOOK_ORDER]
    },
  },
  watch: {
    priceBookFile: {
      handler(val) {
        if (!val) {
          return
        }
        analytics.track(MASTER_PRICE_BOOK.BRAND_SELECTS_MASTER_PRICE_BOOK_FILE, val)
      },
      deep: true,
    },
    isUploadingCurrencyBook(val) {
      if (val) {
        window.addEventListener('beforeunload', this.handleBeforeUnload)
      } else {
        window.removeEventListener('beforeunload', this.handleBeforeUnload)
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isUploadingCurrencyBook) {
      // eslint-disable-next-line no-alert
      const answer = window.confirm('Do you really want to leave? Some changes may get lost.')
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  methods: {
    handleBeforeUnload(e) {
      e.preventDefault()
      e.returnValue = ''
    },
      // Segmentation Book methods
    async openSegmentationBook() {
      this.$bvModal.show(`${this.collection._id}-segmentation-book`)
      this.isLoadingSegmentationBooks = true
      try {
        const response = await this.$store.dispatch(GET_SEGMENTATION_BOOKS, this.collection._id)
        this.segmentationBooks = response.data.data
      } catch (err) {
        // error toast handled by axios interceptor
      } finally {
        this.isLoadingSegmentationBooks = false
      }
    },

    async createSegmentationBook() {
      this.isCreatingSegmentationBook = true
      try {
        const payload = {
          segmentationBookName: this.segmentationBookName,
        }
        const response = await this.$store.dispatch(CREATE_SEGMENTATION, { payload, collectionId: this.collection._id })
        apiToastSuccess(response.data.message)
        const res = await this.$store.dispatch(GET_SEGMENTATION_BOOKS, this.collection._id)
        this.segmentationBooks = res.data.data
        this.showCreateSegmentationBook = false
        this.segmentationBookName = null
      } catch (err) {
        // error toast handled by axios interceptor
      } finally {
        this.isCreatingSegmentationBook = false
      }
    },

    startRename(book) {
      this.$set(book, 'isEditing', true)
      this.$set(book, 'newName', book.segmentationBookName)
    },
    extractNameAndCurrencyFromPriceBook(priceBookName) {
      const match = priceBookName.match(/(.*?)\s*\(([^)]*)\)\s*$/)
      if (match) {
        return {
          name: match[1].trim(),
          currency: match[2].trim(),
        }
      }
      return {
        name: priceBookName,
        currency: null,
      }
    },

    startRenamePricebook(book) {
      this.$set(book, 'isEditing', true)
      const { name } = this.extractNameAndCurrencyFromPriceBook(book.priceBookName)
      this.$set(book, 'newName', name)
    },

    async renameBook(book, action, getAction, listProperty) {
      if (this.isRenaming) return
      this.isRenaming = true
      try {
        const payload = { name: book.newName }
        const response = await this.$store.dispatch(action, { payload, [action === RENAME_PRICEBOOK ? 'priceBookId' : 'segmentationId']: book._id })
        apiToastSuccess(response.data.message)
        const res = await this.$store.dispatch(getAction, this.collection._id)
        this[listProperty] = res.data.data
        this.$delete(book, 'isEditing')
        this.$delete(book, 'newName')
      } catch (err) {
        // error toast handled by axios interceptor
      } finally {
        this.isRenaming = false
      }
    },
    async renamePriceBook(priceBook) {
      await this.renameBook(priceBook, RENAME_PRICEBOOK, GET_PRICE_BOOK, 'priceBookList')
    },
    async renameSegmentationBook(book) {
      await this.renameBook(book, RENAME_SEGMENTATION, GET_SEGMENTATION_BOOKS, 'segmentationBooks')
    },

    validateName(name) {
      if (!name || name.trim().length === 0 || name.length > 25) return false
      return true
    },

    handleNameInput(value, book, field) {
      if (value.length > 25) {
        this.$set(book, field, value.slice(0, 25))
      }
      // Trim any whitespace
      this.$set(book, field, value.trim())
    },

    cancelRename(book) {
      this.$delete(book, 'isEditing')
      this.$delete(book, 'newName')
    },

    async confirmDelete(type, message) {
      return this.$bvModal.msgBoxConfirm(message, {
        title: `Delete ${type}`,
        okVariant: 'danger',
        okTitle: 'Delete',
        cancelTitle: 'Cancel',
      })
    },

    async deleteBook(type, book) {
      try {
        const isSegmentation = type === 'Segmentation Book'
        const message = `Are you sure you want to delete this ${type.toLowerCase()}? It will be unassigned from the retailer. This action will not impact any of your existing orders.`
        const confirmed = await this.confirmDelete(type, message)
        if (!confirmed) return

        if (isSegmentation) {
          const response = await this.$store.dispatch(DELETE_SEGMENTATION_BOOK, { segmentationId: book._id })
          apiToastSuccess(response.data.message)
          const res = await this.$store.dispatch(GET_SEGMENTATION_BOOKS, this.collection._id)
          this.segmentationBooks = res.data.data
        } else {
          const response = await this.$store.dispatch(DELETE_PRICEBOOK, { priceBookId: book._id })
          apiToastSuccess(response.data.message)
          const res = await this.$store.dispatch(GET_PRICE_BOOK, this.collection._id)
          this.priceBookList = res.data.data
        }
      } catch (err) {
        // error toast handled by axios interceptor
      }
    },

    async deleteSegmentationBook(book) {
      return this.deleteBook('Segmentation Book', book)
    },

    async deletePricebook(book) {
      return this.deleteBook('Price Book', book)
    },
    async exportBook(book, options) {
      const {
        endpoint, fileName, successMessage, successTrack, failTrack,
        isExportingProperty, exportingIdProperty, bookIdProperty,
        requiresCollectionId = false,
      } = options
      this[isExportingProperty] = true
      if (exportingIdProperty) {
        this[exportingIdProperty] = book[bookIdProperty]
      }
      const url = requiresCollectionId && this.collectionId
        ? this.$kpParams(endpoint, this.collectionId, book[bookIdProperty])
        : this.$kpParams(endpoint, book[bookIdProperty])
      const payload = {
        url,
        fileName,
        fileFormat: FILE_FORMATS.XLSX,
        successMessage,
      }
      try {
        const res = await this.$store.dispatch(DOWNLOAD_FILE, payload)
        analytics.track(successTrack, { bookId: book[bookIdProperty], fileObject: res })
      } catch (err) {
        analytics.track(failTrack, { error: parseErrorObject(err) })
      } finally {
        this[isExportingProperty] = false
        if (exportingIdProperty) {
          this[exportingIdProperty] = null
        }
      }
    },
    exportSegmentationBook(book) {
      this.exportBook(book, {
        endpoint: this.$kpEndpoint.catalog.segmentation.export,
        fileName: `${book?.segmentationBookName}-segmentation-book.xlsx`,
        successMessage: 'Segmentation book exported successfully',
        successTrack: 'SEGMENTATION_BOOK_EXPORTED_SUCCESSFULLY',
        failTrack: 'SEGMENTATION_BOOK_EXPORT_FAILED',
        isExportingProperty: 'isExportingSegmentationBook',
        exportingIdProperty: 'exportingSegmentationBookId',
        bookIdProperty: '_id',
        requiresCollectionId: false,
      })
    },

    onClickImportSegmentationBook(book = null) {
      this.selectedSegmentationBook = book
      this.isImportingSegmentationBook = true
    },

    onClickBackSegmentationBook() {
      this.selectedSegmentationBook = null
      this.isImportingSegmentationBook = false
      this.segmentationBookFile = null
    },

    async importSegmentationBook() {
      this.isUploading = true
      try {
        const fileLink = await this.$store.dispatch(UPLOAD_DOCUMENTS, {
          fileType: FILE_TYPES.PRICE_BOOK,
          file: this.segmentationBookFile,
        })
        const payloadObject = {
          collectionId: this.collection?._id,
          payload: {
            segmentationBookFile: fileLink,
          },
        }
        if (this.selectedSegmentationBook?._id) {
          payloadObject.segmentationId = this.selectedSegmentationBook._id
        }
        const result = await this.$store.dispatch(IMPORT_SEGMENTATION, payloadObject)
        apiToastSuccess(result.data.message)
        this.isImportingSegmentationBook = false
        this.segmentationBookFile = null
        this.selectedSegmentationBook = null
        analytics.track('SEGMENTATION_BOOK_IMPORTED_SUCCESSFULLY', {
          importedFile: fileLink,
          collection: this.collection,
        })
      } catch (err) {
        analytics.track('SEGMENTATION_BOOK_IMPORT_FAILED', { error: parseErrorObject(err) })
      } finally {
        this.isUploading = false
      }
    },

    closeSegmentationBook() {
      this.selectedSegmentationBook = null
      this.isUploading = false
      this.isCreatingSegmentationBook = false
      this.segmentationBookName = null
      this.isImportingSegmentationBook = false
      this.segmentationBookFile = null
      this.showCreateSegmentationBook = false
    },

    onClickCloseSegmentationBook() {
      if (this.isImportingSegmentationBook) {
        this.onClickBackSegmentationBook()
        return
      }
      this.$bvModal.hide(`${this.collection._id}-segmentation-book`)
    },
    resetCurrencyInput() {
      this.selectedCurrency = null
      this.showAddCurrencyField = false
      this.selectedCurrencyForImport = ''
      this.currencyBookFile = null
    },
    getPriceBookNameWithoutCurrency(name) {
      if (!name) return ''
      const match = name.match(/(.*?)\s*\([A-Z]{3}\)\s*$/)
      return match ? match[1].trim() : name.trim()
    },
    getPriceBookCurrency(name) {
      if (!name) return ''
      const match = name.match(/\(([A-Z]{3})\)\s*$/)
      return match ? match[1] : ''
    },
    async exportCurrencies(currency = '') {
      this.isExportingCurrency = true
      this.exportingCurrency = currency

      const params = {
        collectionId: this.collection._id,
      }
      let fileName = ''
      if (currency) {
        params.currency = currency
        fileName = `${this.collection.name}-${currency}-currency-book.xlsx`
      } else {
        fileName = `${this.collection.name}-master-currency-book.xlsx`
      }

      const payload = {
          url: await this.$store.dispatch(EXPORT_CURRENCIES, params),
          fileName,
          fileFormat: FILE_FORMATS.XLSX,
          successMessage: 'Currency book exported successfully',
        }
      this.$store.dispatch(DOWNLOAD_FILE, payload).then(() => {
        this.isExportingCurrency = false
        this.exportingCurrency = ''
      }).catch(() => {
        this.isExportingCurrency = false
        this.exportingCurrency = ''
      })
    },
    onAddCurrency() {
      if (!this.selectedCurrency) {
        return
      }
      if (this.currencyFileList.includes(this.selectedCurrency) || this.selectedCurrency === this.baseCurrency) {
        apiToastWarning('Base currency prices can be updated from collection book')
        return
      }
      this.isSavingCurrency = true
      const payload = {
        currencies: [...this.currencyFileList, this.selectedCurrency],
      }
      this.$store.dispatch(UPDATE_CURRENCIES, { collectionId: this.collection._id, payload }).then(res => {
        apiToastSuccess(res.data.message)
        this.isSavingCurrency = false
        this.currencyFileList.push(this.selectedCurrency)
        this.resetCurrencyInput()
        this.fetchCollections()
      }).catch(() => {
        this.isSavingCurrency = false
      })
    },
    searchCurrency(searchString) {
      const searchRegex = new RegExp(searchString, 'i')
      this.currencies = availableCurrencies.filter(currency => searchRegex.test(currency))
    },
    onSelectCurrency(currency) {
      if (this.selectedCurrency === currency) {
        this.selectedCurrency = null
        return
      }
      this.selectedCurrency = currency
    },
    onClickImportCurrency(currency = '') {
      this.selectedCurrencyForImport = currency
    },
    async getCollectionOrderData() {
      try {
        const response = await this.$store.dispatch(GET_ORDERS_INFO_BY_COLLECTION_ID_AND_CURRENCY, {
          collectionId: this.collection._id,
          currencies: this.selectedCurrencyForImport === this.baseCurrency ? this.currencyFileList : [this.selectedCurrencyForImport],
        })
        return response.data.data
      } catch (error) {
        console.error(error)
      }
    },
    handleDragOver() {
      this.isDragging = true
    },
    handleDragLeave() {
      this.isDragging = false
    },
    onDropCurrencyFile(event) {
      this.isDragging = false
      event.preventDefault()
      this.currencyBookFile = event.dataTransfer.files[0]
    },
    onDropPriceBookFile(event) {
      this.isDragging = false
      event.preventDefault()
      this.priceBookFile = event.dataTransfer.files[0]
    },
    async handleCurrencyImport() {
      this.isUploadingCurrencyBook = true
      try {
        const orderData = await this.getCollectionOrderData()
        if (orderData.length > 0) {
          this.conflictingOrders = orderData.map(order => ({ ...order, orderId: order._id }))
          this.isUploadingCurrencyBook = false
          this.$bvModal.show(`orders_currency_update_warning_${this.collection._id}`)
        } else {
          await this.importCurrencyBookFile([])
        }
      } catch (error) {
        this.isUploadingCurrencyBook = false
      }
    },
    async handleDoNotUpdateOrders() {
      await this.importCurrencyBookFile([])
    },
    async handleUpdateOrders(orderIds) {
      await this.importCurrencyBookFile(orderIds)
    },
    async importCurrencyBookFile(selectedOrderIds) {
      this.isUploadingCurrencyBook = true
      try {
        const fileUrl = await this.$store.dispatch(UPLOAD_DOCUMENTS, { file: this.currencyBookFile, fileType: FILE_TYPES.MULTICURRENCY_BOOK })
        const params = {
          collectionId: this.collection._id,
        }
        if (this.selectedCurrencyForImport && this.selectedCurrencyForImport !== this.baseCurrency) {
          params.currency = this.selectedCurrencyForImport
        }
        const importResponse = await this.$store.dispatch(IMPORT_CURRENCIES, { params, payload: { fileUrl, orderIds: selectedOrderIds } })
        apiToastSuccess(importResponse.data.message)
        this.currencyBookFile = null
        this.selectedCurrencyForImport = ''
        this.$bvModal.hide(`orders_currency_update_warning_${this.collection._id}`)
        this.$bvModal.hide(`select_orders_for_currency_update_${this.collection._id}`)
      } catch (error) {
        // error toast handled by axios interceptor
      } finally {
        this.isUploadingCurrencyBook = false
        this.conflictingOrders = []
      }
    },
    toggleSelectAllOrders() {
      if (this.isSelectedOrders) {
        this.selectedOrders = []
        return
      }
      this.selectedOrders = this.orderList.map(order => order._id)
    },
    onSearchOrders(searchString = '') {
  const searchRegex = new RegExp(searchString, 'i')
  this.orderList = this.confirmedOrders.filter(order => searchRegex.test(order?.orderSeqId) || searchRegex.test(order?.retailerName))
},
    closeModal() {
      this.catalogFile = null
      this.catalogFileLink = null
      this.$bvModal.hide(`updateavailability_${this.collection._id}`)
      this.$bvModal.hide(`selectorders_${this.collection._id}`)
      // Hide currency book modal
      this.$bvModal.hide(`${this.collection._id}_currency_book`)
    },

    updateDefaultSelectedOption() {
      this.getConfirmedOrders()
    },
    async downloadCatalog() {
      const payload = {
        downloadType: DOWNLOAD_TYPES.AVAILABILITY_EXPORT.VALUE,
        fileType: FILE_FORMATS.XLSX,
        respectiveId: this.collection._id,
      }
      try {
        const res = await this.$store.dispatch(DOWNLOAD_AVAILABILITY, { payload })
        apiToastSuccess(res.data?.message || 'Your file is being prepared. Check the Downloads tab.')
        this.notifyDownloadsNavMenu()
      } catch (err) {
        apiToastWarning(err)
      }
    },
    openOrdersModal() {
      if (this.confirmedOrders.length) {
        this.$bvModal.hide(`updateavailability_${this.collection._id}`)
        this.$bvModal.show(`selectorders_${this.collection._id}`)
      } else {
        this.uploadCollection()
      }
    },
    async uploadCollection() {
      this.isSaving = true
      if (this.catalogFile && this.collectionId) {
        const payload = {
          productAvailabilityFile: await this.$store.dispatch(UPLOAD_DOCUMENTS, { file: this.catalogFile, fileType: FILE_TYPES.COLLECTION_PRODUCTS_DETAILED }),
          orderIds: this.selectedOrders,
        }
        store
          .dispatch(UPDATE_COLLECTION, {
            collectionId: this.collection._id,
            payload,
          })
          .then(res => {
            apiToastSuccess(res.data.message)
            this.isSaving = false
            this.closeModal()
            analytics.track(
              constants.TRACKS.ACTIONS.BRAND_ENDS_UPDATING_AVAILABILITY_DATES,
              formatObject(
                getCollectionMixpanelObj(this.collection, {
                  updateAvailabilityStatus: 'Success',
                }),
              ),
            )
          })
          .catch(err => {
            this.isSaving = false
            analytics.track(
              constants.TRACKS.ACTIONS.BRAND_ENDS_UPDATING_AVAILABILITY_DATES,
              formatObject(
                getCollectionMixpanelObj(this.selectedCollection, {
                  updateAvailabilityStatus: 'Error',
                  error: parseErrorObject(err),
                }),
              ),
            )
          })
      } else {
        this.isSaving = false
        apiToastWarning('Please Select File')
      }
    },
    closeOrderModal() {
      this.$bvModal.hide(`selectorders_${this.collection._id}`)
      this.$bvModal.show(`updateavailability_${this.collection._id}`)
    },
    getConfirmedOrders() {
      store.dispatch(GET_ORDERS_BY_COLLECTION_SEQ_IDS, this.collection._id).then(res => {
        this.confirmedOrders = res.data.data.orders
        this.orderList = this.confirmedOrders
      })
    },
    async getCollectionPriceBook(shouldOpenPopup = false) {
      try {
        const reusult = await this.$store.dispatch(GET_PRICE_BOOK, this.collectionId)
        this.priceBookList = reusult.data?.data || []
        if (shouldOpenPopup) {
          this.$bvModal.show(`${this.collection._id}-price-book`)
          this.showCreatePriceBook = !this.priceBookList.length
        }
      } catch (err) {
        // error toast handled by axios interceptor
      }
    },
    openCurrencyBook() {
      this.currencyFileList = this.collection?.availableCurrencies || []
      this.$bvModal.show(`${this.collection._id}_currency_book`)
    },
    async createPriceBook() {
      this.isCreating = true
      try {
        const payload = {
          priceBookName: this.priceBookName,
          currency: this.selectedCurrency || null,
        }
        const result = await this.$store.dispatch(CREATE_PRICE_BOOK, { payload, collectionId: this.collectionId })
        this.getCollectionPriceBook()
        this.priceBookName = ''
        this.showCreatePriceBook = false
        apiToastSuccess(result.data.message || 'Price book created successfully')
      } catch (err) {
        // error toast handled by axios interceptor
      } finally {
        this.isCreating = false
      }
    },
    cancelCreatePriceBook() {
      if (this.priceBookList.length) {
        this.showCreatePriceBook = false
      }
      else {
        this.$bvModal.hide(`${this.collectionId}-price-book`)
      }
      this.selectedCurrency = null
    },
    async exportMasterBook(options) {
      const {
        downloadType, action, successTrack, failTrack, isExportingProperty,
      } = options
      this[isExportingProperty] = true
      if (downloadType === 'masterPricebookExport') {
        analytics.track(MASTER_PRICE_BOOK.BRAND_CLICKS_EXPORT_MASTER_PRICE_BOOK)
      }
      const payload = {
        downloadType,
        fileType: FILE_FORMATS.XLSX,
        respectiveId: this.collectionId,
      }
      try {
        const res = await this.$store.dispatch(action, { payload })
        apiToastSuccess(res.data?.message)
        analytics.track(successTrack, { fileObject: res })
        this.notifyDownloadsNavMenu()
      } catch (err) {
        analytics.track(failTrack, { error: parseErrorObject(err) })
      } finally {
        this[isExportingProperty] = false
      }
    },
    exportMasterPriceBook() {
      this.exportMasterBook({
        downloadType: 'masterPricebookExport',
        action: DOWNLOAD_MASTER_PRICEBOOK,
        successTrack: MASTER_PRICE_BOOK.MASTER_PRICE_BOOK_EXPORTED_SUCCESSFULLY,
        failTrack: MASTER_PRICE_BOOK.MASTER_PRICE_BOOK_EXPORT_FAILED,
        isExportingProperty: 'isExportingPriceBook',
      })
    },
    exportMasterSegmentationBook() {
      this.exportMasterBook({
        downloadType: 'masterSegmentationBookExport',
        action: DOWNLOAD_MASTER_SEGMENTATION_BOOK,
        successTrack: MASTER_PRICE_BOOK.MASTER_SEGMENTATION_BOOK_EXPORTED_SUCCESSFULLY,
        failTrack: MASTER_PRICE_BOOK.MASTER_SEGMENTATION_BOOK_EXPORT_FAILED,
        isExportingProperty: 'isExportingSegmentationBook',
      })
    },
    exportPriceBook(priceBook) {
      this.exportBook(priceBook, {
        endpoint: this.$kpEndpoint.catalog.pricebook.export,
        fileName: `${priceBook?.priceBookName}-price-book.xlsx`,
        successMessage: 'Price book exported successfully',
        successTrack: MASTER_PRICE_BOOK.MASTER_PRICE_BOOK_EXPORTED_SUCCESSFULLY,
        failTrack: MASTER_PRICE_BOOK.MASTER_PRICE_BOOK_EXPORT_FAILED,
        isExportingProperty: 'isExportingPriceBook',
        exportingIdProperty: 'exportingPriceBookId',
        bookIdProperty: '_id',
        requiresCollectionId: true,
      })
    },
    onClickImportPriceBook(priceBook = null) {
      this.selectedPriceBook = priceBook
      this.isImportingPriceBook = true
      if (!priceBook) {
        analytics.track(MASTER_PRICE_BOOK.BRAND_CLICKS_IMPORT_BTN_TO_OPEN_FILE_UPLOAD_POPUP)
      }
    },
    onClickBackPriceBook() {
      this.selectedPriceBook = null
      this.isImportingPriceBook = false
      this.priceBookFile = null
      analytics.track(MASTER_PRICE_BOOK.BRAND_CLICKS_BACK_BTN_ON_FILE_UPLOAD_POPUP)
    },
    async importPriceBook() {
      analytics.track(MASTER_PRICE_BOOK.BRAND_CLICKS_IMPORT_BTN_ON_FILE_UPLOAD_POPUP, this.priceBookFile)
      this.isUploading = true
      const currentSelectedPriceBook = this.selectedPriceBook

      try {
        const fileLink = await this.$store.dispatch(UPLOAD_DOCUMENTS, { fileType: FILE_TYPES.PRICE_BOOK, file: this.priceBookFile })
        this.uploadedPriceBookFileLink = fileLink

        if (this.hasImportPricebookOrderFeature) {
          await this.handleImportWithOrderSelection(fileLink, currentSelectedPriceBook)
        } else {
          await this.handleDirectImport(fileLink, currentSelectedPriceBook)
        }
      } catch (err) {
        analytics.track(MASTER_PRICE_BOOK.MASTER_PRICE_BOOK_IMPORT_FAILED, { error: parseErrorObject(err) })
      } finally {
        this.isUploading = false
      }
    },
    preserveSelectedPriceBook(currentSelectedPriceBook) {
      if (currentSelectedPriceBook && !this.selectedPriceBook) {
        this.selectedPriceBook = currentSelectedPriceBook
      }
    },
    async handleImportWithOrderSelection(fileLink, currentSelectedPriceBook) {
      this.preserveSelectedPriceBook(currentSelectedPriceBook)

      const ordersResponse = await this.$store.dispatch(GET_ORDERS_BY_COLLECTION_SEQ_IDS, this.collection?._id)
      const orders = ordersResponse?.data?.data?.orders || []

      if (orders.length > 0) {
        await this.showOrderSelectionModal(orders, currentSelectedPriceBook)
      } else {
        await this.importWithoutOrders(fileLink, currentSelectedPriceBook)
      }
    },
    async showOrderSelectionModal(orders, currentSelectedPriceBook) {
      this.allPriceBookOrders = orders
      this.priceBookOrderList = orders
      this.isUploading = false
      this.preserveSelectedPriceBook(currentSelectedPriceBook)

      this.$bvModal.hide(`${this.collection._id}-price-book`)
      this.$nextTick(() => {
        this.preserveSelectedPriceBook(currentSelectedPriceBook)
        this.$bvModal.show(`select_orders_pricebook_import_${this.collection._id}`)
      })
    },
    async importWithoutOrders(fileLink, currentSelectedPriceBook) {
      this.preserveSelectedPriceBook(currentSelectedPriceBook)
      await this.performPriceBookImport(fileLink, [])
      this.$bvModal.hide(`${this.collection._id}-price-book`)
    },
    async handleDirectImport(fileLink, currentSelectedPriceBook) {
      this.preserveSelectedPriceBook(currentSelectedPriceBook)
      await this.performPriceBookImport(fileLink, [])
      this.$bvModal.hide(`${this.collection._id}-price-book`)
    },
    async confirmPriceBookImport() {
      this.isUploading = true
      try {
        // Import with selected orders (can be empty array if no orders selected)
        const orderIds = this.selectedPriceBookOrders.length > 0 ? this.selectedPriceBookOrders : []
        await this.performPriceBookImport(this.uploadedPriceBookFileLink, orderIds)
        this.$bvModal.hide(`select_orders_pricebook_import_${this.collection._id}`)
        this.$bvModal.hide(`${this.collection._id}-price-book`)
      } catch (err) {
        analytics.track(MASTER_PRICE_BOOK.MASTER_PRICE_BOOK_IMPORT_FAILED, { error: parseErrorObject(err) })
      } finally {
        this.isUploading = false
      }
    },
    async performPriceBookImport(fileLink, orderIds) {
      const payload = {
        priceBookFile: fileLink,
      }
      // Only include orderIds in payload if orders are selected
      if (orderIds && orderIds.length > 0) {
        payload.orderIds = orderIds
      }

      const payloadObject = {
        collectionId: this.collection?._id,
        payload,
      }
      // Set priceBookId only if a specific price book is selected (not master)
      // This works for both individual and master imports - individual when priceBookId exists, master when it doesn't
      const priceBookId = this.selectedPriceBook?._id
      if (priceBookId) {
        payloadObject.priceBookId = priceBookId
      }

      const result = await this.$store.dispatch(IMPORT_PRICE_BOOK, payloadObject)
      apiToastSuccess(result.data.message)
      this.isImportingPriceBook = false
      this.priceBookFile = null
      this.selectedPriceBook = null
      this.uploadedPriceBookFileLink = null
      this.priceBookOrderList = []
      this.allPriceBookOrders = []
      this.selectedPriceBookOrders = []
      analytics.track(MASTER_PRICE_BOOK.MASTER_PRICE_BOOK_IMPORTED_SUCCESSFULLY, { importedFile: fileLink, collection: this.collection })
    },
    closePriceBookOrderModal() {
      this.$bvModal.hide(`select_orders_pricebook_import_${this.collection._id}`)
      this.$bvModal.show(`${this.collection._id}-price-book`)
      this.priceBookOrderList = []
      this.allPriceBookOrders = []
      this.selectedPriceBookOrders = []
      this.uploadedPriceBookFileLink = null
    },
    resetSelectedPriceBookOrders() {
      this.selectedPriceBookOrders = []
    },
    onSearchPriceBookOrders(searchString = '') {
      if (!searchString) {
        this.priceBookOrderList = [...this.allPriceBookOrders]
        return
      }
      const searchRegex = new RegExp(searchString, 'i')
      this.priceBookOrderList = this.allPriceBookOrders.filter(order => {
        const seqId = (order.orderSeqId || order.seqId || '').toString()
        const retailerName = (order.retailerName || '').toString()
        return searchRegex.test(seqId) || searchRegex.test(retailerName)
      })
    },
    toggleSelectAllPriceBookOrders() {
      if (this.isSelectedPriceBookOrders) {
        this.selectedPriceBookOrders = []
      } else {
        // Select all orders from the full list, not just filtered
        const allOrderIds = this.allPriceBookOrders.map(order => order._id)
        // Also include any already selected orders that might not be in current filter
        const currentSelected = new Set(this.selectedPriceBookOrders)
        allOrderIds.forEach(id => currentSelected.add(id))
        this.selectedPriceBookOrders = Array.from(currentSelected)
      }
    },
    onPriceBookModalHide() {
      // Only reset if we're not in the middle of an import flow
      // Don't reset selectedPriceBook if we're showing the order selection modal
      const isOrderSelectionModalOpen = document.getElementById(`select_orders_pricebook_import_${this.collection._id}`)?.classList.contains('show')
      if (!isOrderSelectionModalOpen && !this.isImportingPriceBook) {
        this.selectedPriceBook = null
        this.isUploading = false
        this.isCreating = false
        this.priceBookName = null
        this.priceBookFile = null
        this.selectedCurrency = null
      }
    },
    closePriceBook() {
      this.selectedPriceBook = null
      this.isUploading = false
      this.isCreating = false
      this.priceBookName = null
      this.isImportingPriceBook = false
      this.priceBookFile = null
      this.selectedCurrency = null
    },
    onClickClosePriceBook() {
      if (this.isImportingPriceBook) {
        this.onClickBackPriceBook()
        return
      }
      this.$bvModal.hide(`${this.collection._id}-price-book`)
    },
  },
}
</script>

<style lang="scss">
.add-currency-container {
  padding: 10px;
  background: #DFDFDFB2;
  border-radius: 5px;
}

.rename-box {
  position: relative;
  display: inline-block;
  width: 300px; // Adjust as needed for your design
}

.rename-input {
  width: 250px !important; // Slightly less than .rename-box to fit icons
  padding-right: 70px !important;
  &:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: #d8d6de !important;
  }
  &.is-valid {
    border-color: #d8d6de !important;
    background-image: none !important;
  }
}

.rename-actions {
  position: absolute;
  left: 190px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  gap: 1px;
}

.rename-action-icon {
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}

.form-control-merge {
  &:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: #d8d6de !important;
  }
}

.input-group-merge {
  .form-control {
    &:focus {
      border-color: #d8d6de !important;
      box-shadow: none !important;
    }
  }
}

.update-tick {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #28c76f;
  z-index: 3;
}

.cursor-copy {
  cursor: copy !important;
}
</style>
